import { writable } from 'svelte/store';

const STORAGE_KEY = 'shelly-device-settings-advanced';

function readStored(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === '1';
	} catch {
		return false;
	}
}

/**
 * Prototype global Advanced flag. Persists in localStorage until the
 * account-settings API is wired.
 */
export const deviceSettingsAdvanced = writable(readStored());

deviceSettingsAdvanced.subscribe((on) => {
	try {
		localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
	} catch {
		/* ignore quota / private mode */
	}
});
